import moment from 'moment';
import * as Status from '../../../constants/status';

export const getArea = area => {
  if (area === 'RDR') return 'Rural';
  if (area === 'RDU') return 'Urbana';
  return '';
};

export const destacarVencimento = (dataVencimento, dataConclusao) => {
  let cor = '#037503';
  const diffInWeeks = moment
    .duration(dataVencimento.diff(dataConclusao))
    .asWeeks();

  if (diffInWeeks <= 0) cor = '#ad0909';
  else if (diffInWeeks <= 1) cor = '#bd8c00';

  return {
    color: cor,
    border: `1px solid ${cor}`,
  };
};

export const obterTextoVencimento = (dataVencimento, dataConclusao) => {
  const diffInWeeks = moment
    .duration(dataVencimento.diff(dataConclusao))
    .asWeeks();
  const prefixDiffText = diffInWeeks < 0 ? 'Vencido' : 'Vencerá';
  return `${prefixDiffText} ${dataVencimento
    .locale('pt-br')
    .from(dataConclusao)}`;
};

export const formatDate = (date) => moment(date).format('DD/MM/YYYY');

export const shouldShowExpirationChip = (rowData) =>
  !rowData.dataConclusao && rowData.status !== Status.EXECUTADA_GDIS;
